<template>
  <div :class="$style.blankPageLayout">
    <div :class="$style.content">
      <slot />
    </div>
  </div>
</template>

<style module lang="scss">
.blankPageLayout {
  @apply flex flex-col items-center justify-center bg-bg-primary relative h-screen w-full overflow-x-hidden;

  width: 100dvw;
  height: 100dvh;

  .content {
    @apply w-full mx-auto max-w-full h-full relative z-10 p-0 md:pt-0;
  }
}
</style>
